import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addCargo,
  deleteCargo,
  fetchCargoList,
  updateCargo,
  moveCargo,
} from "../../apis/cargo";

import type { CargoPayload } from "../../utils/types/cargo";

export const fetchCargoListData = createAsyncThunk(
  "cargo/fetchCargoList",
  async ({ berthId }: { berthId: string }, { rejectWithValue }) => {
    try {
      const response = await fetchCargoList(berthId);
      return {
        data: response,
        berthId,
      }
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateCargoData = createAsyncThunk(
  "cargo/updateCargo",
  async (
    {
      id,
      berthId,
      data,
    }: {
      id: string;
      berthId: string;
      data: { [key: string]: any; cargoId: string };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateCargo(id, berthId, data);
      return { success: true, data, berthId };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteCargoData = createAsyncThunk(
  "cargo/deleteCargo",
  async (
    { id, berthId }: { id: string; berthId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteCargo({ id, berthId });
      if (response.success) {
        return { cargoId: id, berthId, success: true };
      }
      return rejectWithValue("Unknown error… Please try again");
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addCargoData = createAsyncThunk(
  "cargo/addCargo",
  async ({ data }: { data: CargoPayload }, { rejectWithValue }) => {
    try {
      const response = await addCargo(data);
      return {
        data: response,
        berthId: data.berthId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const moveCargoData = createAsyncThunk(
  "cargo/moveCargo",
  async (
    {
      id,
      berthId,
      currentBerthId
    }: {
      id: string;
      berthId: string;
      currentBerthId:string
    },
    { rejectWithValue }
  ) => {
    try {
      await moveCargo(id, berthId);
      return {
        success: true,
        cargoId: id,
        data: {
          berthId,
          currentBerthId
        },
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
